/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartTypeResponse
 */
export interface PartTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof PartTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PartTypeResponse
     */
    categoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof PartTypeResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartTypeResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the PartTypeResponse interface.
 */
export function instanceOfPartTypeResponse(value: object): value is PartTypeResponse {
    return true;
}

export function PartTypeResponseFromJSON(json: any): PartTypeResponse {
    return PartTypeResponseFromJSONTyped(json, false);
}

export function PartTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function PartTypeResponseToJSON(json: any): PartTypeResponse {
    return PartTypeResponseToJSONTyped(json, false);
}

export function PartTypeResponseToJSONTyped(value?: PartTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'name': value['name'],
        'description': value['description'],
    };
}

